module.exports = __webpack_public_path__ + "static/media/vegitables_7.85c9571a.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_7.csv
// module id = 657
// module chunks = 0